import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'src/app/_models/subscription';
import { AdminSubscriptionService } from 'src/app/_services/admin-subscription.service';

@Component({
    selector: 'app-subscriptions-list',
    templateUrl: './subscriptions-list.component.html',
    styleUrls: ['./subscriptions-list.component.css'],
    standalone: false
})
export class SubscriptionsListComponent implements OnInit, OnDestroy {

    subscriptions: Subscription[] = [];
    loading = false;
    config: any;
    page = 1;
    itemPerPage = 30;

    constructor(
        private adminSubscriptionService: AdminSubscriptionService,
        private router: Router,
        private titleService: Title
    ) {
        this.titleService.setTitle('Subscriptions');
    }

    ngOnInit(): void {
        this.loadSubscriptions();
    }

    ngOnDestroy(): void {
        this.titleService.setTitle('');
    }

    loadSubscriptions(): void {
        this.loading = true;

        this.adminSubscriptionService.loadSubscriptions(this.page).subscribe({
            next: (response: any) => {

                console.log('FULL RESPONSE =>', response);
                console.log('response.data =>', response?.data);
                console.log('response.data.data =>', response?.data?.data);

                // Try Swagger structure first
                if (Array.isArray(response?.data?.data)) {
                    this.subscriptions = response.data.data.filter(sub => sub.status === 'ACTIVE' || sub.status === 'EXPIRED');
                    this.setupPagination(response.data);
                }

                // Fallback if service already unwraps data
                else if (Array.isArray(response?.data)) {
                    this.subscriptions = response.data.filter(sub => sub.status === 'ACTIVE' || sub.status === 'EXPIRED');
                    this.setupPagination(response);
                }

                else {
                    console.error('Unexpected response structure', response);
                    this.subscriptions = [];
                }

                console.log('SUBSCRIPTIONS =>', this.subscriptions);
                console.log('IS ARRAY =>', Array.isArray(this.subscriptions));
                console.log('LENGTH =>', this.subscriptions?.length);

                this.loading = false;
            },
            error: (err) => {
                console.error('API ERROR =>', err);
                this.loading = false;
            }
        });
    }

    setupPagination(response: any): void {
        this.config = {
            currentPage: response?.page || 1,
            itemsPerPage: this.itemPerPage,
            totalItems: response?.totalOfItems || 0,
            id: 'subscriptions-listing'
        };
    }

    pageChange(page: number): void {
        this.page = page;
        this.loadSubscriptions();
    }
}